// ==============================|| OVERRIDES - LIST ITEM BUTTON ||============================== //

export default function ListItemButton(theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
          '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
          },
        },
      },
    },
  }
}
